import { ClientType } from './client.types';
import { UserType } from './user.types';

export type ChecklistItemType = {
  _id?: string;
  description: string;
  executionOrder: number;
  requireSignature: boolean;
  type: 'image_capture' | 'update_data' | 'update_equipment' | 'collect_signature' | 'simple_check' | 'value_input';
  value?: string;
  parentItemId?: string;
  isCompleted?: boolean;
  completedAt?: string;
  completedBy?: string | UserType;
  notes?: string;
  images?: Array<{
    url: string;
    filename: string;
    uploadDate: string;
  }>;
  signature?: {
    url: string;
    signedBy: string;
    signedAt: string;
  };
};

export type ChecklistTemplateType = {
  _id: string;
  name: string;
  description?: string;
  serviceType: 'maintenance' | 'installation' | 'inspection' | 'repair' | 'other';
  items: ChecklistItemType[];
  isActive: boolean;
  createdBy: string | UserType;
  createdAt: string;
  updatedAt: string;
};

export type CommercialVisitType = {
  _id: string;
  number: string;
  client: string | ClientType;
  type: 'presentation' | 'survey' | 'proposal' | 'follow_up' | 'other';
  description: string;
  status: 'scheduled' | 'in_progress' | 'completed' | 'cancelled';
  priority: 'low' | 'medium' | 'high' | 'critical';
  assignedTo: string | UserType;
  representative?: string | UserType;
  scheduledDate: string;
  startDate?: string;
  endDate?: string;
  location?: {
    address?: string;
    latitude?: number;
    longitude?: number;
    updatedAt?: string;
  };
  outcome?: 'pending' | 'successful' | 'unsuccessful' | 'follow_up_required';
  opportunityValue?: number;
  notes?: string;
  attachments?: Array<{
    url: string;
    filename: string;
    contentType: string;
    uploadDate: string;
  }>;
  checklistTemplate?: string | ChecklistTemplateType;
  checklist?: ChecklistItemType[];
  actions?: Array<{
    _id?: string;
    description: string;
    timestamp: string;
    performedBy: string | UserType;
    status: 'info' | 'warning' | 'error' | 'success';
  }>;
  createdBy: string | UserType;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export type CommercialVisitFormValues = Omit<CommercialVisitType, '_id' | 'number' | 'actions' | 'createdBy' | 'isActive' | 'createdAt' | 'updatedAt'>;

export const COMMERCIAL_VISIT_TYPE_LABELS = {
  presentation: 'Apresentação',
  survey: 'Levantamento',
  proposal: 'Proposta',
  follow_up: 'Acompanhamento',
  other: 'Outro'
};

export const COMMERCIAL_VISIT_STATUS_LABELS = {
  scheduled: 'Agendada',
  in_progress: 'Em Andamento',
  completed: 'Concluída',
  cancelled: 'Cancelada'
};

export const COMMERCIAL_VISIT_PRIORITY_LABELS = {
  low: 'Baixa',
  medium: 'Média',
  high: 'Alta',
  critical: 'Crítica'
};

export const COMMERCIAL_VISIT_OUTCOME_LABELS = {
  pending: 'Pendente',
  successful: 'Bem-sucedida',
  unsuccessful: 'Mal-sucedida',
  follow_up_required: 'Requer Acompanhamento'
};

export const COMMERCIAL_VISIT_STATUS_COLORS = {
  scheduled: 'info',
  in_progress: 'warning',
  completed: 'success',
  cancelled: 'error'
};
